"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isParkLosgs = exports.isDeviceESimEligible = exports.getZipChangeModalStatus = exports.isFNCarribeanUser = exports.isCartHasOnlyFNLines = exports.isFNIntentSignOnRequired = exports.isFNItentPresentInOtherLosgs = exports.isFNUserWithConsumerLine = exports.isFNIntentPresent = exports.isPersistedCart = exports.isAtleastOneLineLevelPreOrderIndicator = exports.isAtleastOneLineLevelPrePreOrderIndicator = exports.isPrePreOrder = exports.getRedirectionUrl = exports.ordinalPostFix = exports.isEnablePrescreenCreditCheckOnCart = exports.isPreScreenCreditCheck = exports.isAppreciationOfferPresent = exports.getSavingsPromoFlags = exports.isSpecialBBPricing = exports.isPrivateOffersApplied = exports.isDisplayPrepaidBillingTax = exports.isNewWirelessPostpaidView = exports.getAccessoryCart = exports.getWirelessCart = exports.getLobLosgsCommonCart = exports.isEnableCreditCheckText = exports.isEdspCreditCheck = exports.isIncompleteCart = exports.hasDiscountCategoryTradeIn = exports.getHylaPromotionBillingCode = exports.getHylaPromotionId = exports.CHANNEL_TYPE = exports.getLinkClickBaseUrlforNMDPR = exports.getLinkClickBasekUrl = exports.setCustomerTypeParamsForGlobalNav = exports.globalNavForSMBCustomer = exports.getPlanListFromLOB = exports.getItemsListFromLOB = exports.isQueryInURL = exports.isExpupgradeViewEnable = exports.getIsGigaInCart = exports.getEnabledeviceLegalMessage = exports.getLegalIDPDetails = exports.getLegalIDPUrl = exports.isWirelessPropMessagingEnabled = exports.isSMBCustomer = exports.getPscBBFlag = exports.enableBillComponent = exports.isAcpSystemError = exports.acpVerification = exports.getAcpAccessPromo = exports.getAcpEligibilityPromo = exports.setAcpCustomerPropsInSessionStorage = exports.removeAcpCustomerStatusFromSessionStorage = exports.getAcpCustomerStatusFromSessionStorage = exports.getCloserCouponFlag = exports.checkNewBBCart = exports.getPostpaidflowtype = exports.getTradeInPortInConsented = exports.lobCartKeys = exports.isMobileUserAgent = exports.getUrlParamValue = exports.isSharedRetrievedCart = exports.checkCartRedirectionAfterRemove = exports.getCartPanelCollpaseContext = exports.isBYODFlow = exports.getEAPDetails = exports.checkShareCartEligibility = exports.checkShareCartEligibilityForAndroid = exports.getFinalPrice = exports.getEffectivePricing = exports.getLegalIDPData = exports.displayLineItemPrice = exports.devicePrice = exports.getLineItemPrice = exports.getDeviceDetailsFromLOSG = exports.checkPostpaidPlansFirstFlow = exports.getWirlessLineTypes = void 0;
var commonUtils = require("./UtilityFunctions");
var Common = require("./CommonUtilFuntions");
var routables_1 = require("@idp/routables");
var ReportingService_1 = require("../api/ReportingService");
var LegalAPI_1 = require("../api/LegalAPI");
var CartHelperFunctions_1 = require("./CartHelperFunctions");
var StateProvider_1 = require("../api/StateProvider");
var WirelessUtilFunctions_1 = require("../utils/WirelessUtilFunctions");
function getWirlessLineTypes() {
    var wirlessCartbyodTypes = {
        hasByodInCart: false,
        hasNonByodInCart: false,
    };
    var payload = commonUtils.getCartResp();
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.keys(payload.wirelessCart.losgs).forEach(function (key) {
            if (payload.wirelessCart.losgs[key] &&
                payload.wirelessCart.losgs[key].extraParams &&
                payload.wirelessCart.losgs[key].extraParams.isByod &&
                payload.wirelessCart.losgs[key].
                    extraParams.isByod.toUpperCase() === 'TRUE') {
                wirlessCartbyodTypes.hasByodInCart = true;
            }
            else {
                wirlessCartbyodTypes.hasNonByodInCart = true;
            }
        });
    }
    else if (commonUtils.IsBsseFlow() && commonUtils.IsWirelessInCart()) {
        Object.keys(payload.commonCart.losgs).forEach(function (key) {
            if (payload.commonCart.losgs[key] &&
                payload.commonCart.losgs[key].extraParams &&
                payload.commonCart.losgs[key].extraParams.BYOD &&
                payload.commonCart.losgs[key].
                    extraParams.BYOD.toUpperCase() === 'TRUE') {
                wirlessCartbyodTypes.hasByodInCart = true;
            }
            else {
                wirlessCartbyodTypes.hasNonByodInCart = true;
            }
        });
    }
    return wirlessCartbyodTypes;
}
exports.getWirlessLineTypes = getWirlessLineTypes;
function checkPostpaidPlansFirstFlow() {
    var payload = commonUtils.getCartResp();
    var isPlanfirstFlow = false;
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.keys(payload.wirelessCart.losgs).forEach(function (key) {
            if (payload.wirelessCart.losgs[key] &&
                payload.wirelessCart.losgs[key].extraParams &&
                payload.wirelessCart.losgs[key].extraParams.isPlanFirstLosg &&
                payload.wirelessCart.losgs[key].
                    extraParams.isPlanFirstLosg.toUpperCase() === 'TRUE') {
                isPlanfirstFlow = true;
            }
        });
    }
    return isPlanfirstFlow;
}
exports.checkPostpaidPlansFirstFlow = checkPostpaidPlansFirstFlow;
function getDeviceDetailsFromLOSG(losgID) {
    var payload = commonUtils.getCartResp();
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        var wirelessLosgs = payload.wirelessCart.losgs[losgID];
        var allItemsList = (wirelessLosgs && wirelessLosgs.lineItems && Object.values(wirelessLosgs.lineItems));
        return allItemsList && allItemsList.filter(function (values) { return (values.itemType === 'device'); })[0];
    }
    return null;
}
exports.getDeviceDetailsFromLOSG = getDeviceDetailsFromLOSG;
function getLineItemPrice(losgID) {
    var lineItem = getDeviceDetailsFromLOSG(losgID);
    if (lineItem) {
        var getPromoDetails = getEffectivePricing(lineItem);
        if (displayLineItemPrice(lineItem)) {
            return devicePrice(lineItem);
        }
        else if (getPromoDetails && getPromoDetails.isPromoLineItem
            && getPromoDetails.effectiveDevicePrice === 0) {
            return 0.00;
        }
        else if (getPromoDetails && getPromoDetails.isPromoLineItem
            && getPromoDetails.effectiveDevicePrice > 0) {
            return getPromoDetails.effectiveDevicePrice;
        }
        else if (getPromoDetails && getPromoDetails.isPromoLineItem
            && (getPromoDetails.effectiveDevicePrice > 0 ||
                getPromoDetails.effectiveDevicePrice < 0)) {
            return Math.abs(getPromoDetails.
                effectiveDevicePrice);
        }
    }
    return 0.00;
}
exports.getLineItemPrice = getLineItemPrice;
function devicePrice(lineItem) {
    var finalAmount = getFinalPrice(lineItem.price);
    if (lineItem.contractDetails && (lineItem.contractDetails.contractType === 'LEASE' ||
        lineItem.contractDetails.contractType === 'INSTALLMENT')) {
        finalAmount = lineItem.contractDetails.installmentAmount;
    }
    if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'ACCESSORY' && lineItem.price) {
        finalAmount = lineItem.price.total;
    }
    return finalAmount;
}
exports.devicePrice = devicePrice;
function displayLineItemPrice(lineItem) {
    var displayItemPrice = !!!(lineItem.price);
    var getPromoDetails = getEffectivePricing(lineItem);
    if (getPromoDetails && getPromoDetails.isPromoLineItem) {
        displayItemPrice = false;
    }
    return displayItemPrice;
}
exports.displayLineItemPrice = displayLineItemPrice;
function getLegalIDPData(legalAEMUrl, legalContent, linktext, shortdesc) {
    return __awaiter(this, void 0, void 0, function () {
        var legalApi, response, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    legalApi = new LegalAPI_1.default();
                    if (!legalAEMUrl) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, legalApi.getLegal(legalAEMUrl)];
                case 2:
                    response = _a.sent();
                    if (response.longtext) {
                        legalContent.longtext = response.longtext;
                        legalContent.showLegal = true;
                    }
                    if (response.modaltitle) {
                        legalContent.modaltitle = response.modaltitle;
                    }
                    if (shortdesc) {
                        legalContent.shorttext = shortdesc;
                    }
                    if (linktext) {
                        legalContent.shortdesclinktext = linktext;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    legalContent.showLegal = false;
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, legalContent];
            }
        });
    });
}
exports.getLegalIDPData = getLegalIDPData;
function getEffectivePricing(lineItem) {
    var bogoPricingInfo = {
        effectiveDevicePrice: 0,
        isPromoLineItem: false,
    };
    if (lineItem && lineItem.itemType && lineItem.itemType.toUpperCase() === 'DEVICE' &&
        lineItem.promotionReferences && lineItem.promotionReferences.length > 0 &&
        lineItem.contractDetails && lineItem.contractDetails.contractType &&
        (lineItem.contractDetails.contractType.toUpperCase() === 'LEASE' ||
            lineItem.contractDetails.contractType.toUpperCase() === 'INSTALLMENT') &&
        lineItem.contractDetails._effectiveLeaseAmount !== undefined &&
        lineItem.contractDetails._effectiveLeaseAmount !== lineItem.contractDetails.installmentAmount) {
        bogoPricingInfo.isPromoLineItem = true;
        bogoPricingInfo.effectiveDevicePrice = lineItem.contractDetails._effectiveLeaseAmount;
    }
    return bogoPricingInfo;
}
exports.getEffectivePricing = getEffectivePricing;
function getFinalPrice(price) {
    var finalPrice = 0.00;
    if (price && price.baseAmount && price.amount) {
        if (price.baseAmount && price.baseAmount.toString() !== '0.00') {
            finalPrice = price.baseAmount;
        }
        else {
            finalPrice = price.amount;
        }
    }
    return finalPrice;
}
exports.getFinalPrice = getFinalPrice;
function checkShareCartEligibilityForAndroid() {
    var _a, _b;
    var isEAPFlow = false;
    var wlsPostpaid = JSON.parse(sessionStorage.getItem('wlsPostpaid'));
    if (wlsPostpaid) {
        isEAPFlow = ((_b = (_a = wlsPostpaid.wsceData) === null || _a === void 0 ? void 0 : _a.eapFlow) === null || _b === void 0 ? void 0 : _b.flowType) === 'EAP' ? true : false;
    }
    return isEAPFlow;
}
exports.checkShareCartEligibilityForAndroid = checkShareCartEligibilityForAndroid;
function checkShareCartEligibility() {
    var _a, _b;
    var payload = commonUtils.getCartResp();
    var isShareCartEligible = false;
    if ((commonUtils.IsWirelessInCart()) && (commonUtils.getCurrentFlowType() !== commonUtils.LOBNames.LOB_PREPAID)) {
        var orderSubType = commonUtils.getOrderSubType();
        var respOrderSubType = orderSubType && orderSubType.toUpperCase();
        if (respOrderSubType === CartHelperFunctions_1.FlowType.NEW_WIRELESS
            || respOrderSubType === CartHelperFunctions_1.FlowType.NEW_WIRELESS_NEW_HBOMAX) {
            isShareCartEligible = true;
        }
        if (WirelessUtilFunctions_1.isBYODAndEsim()) {
            isShareCartEligible = false;
        }
    }
    else if (((payload === null || payload === void 0 ? void 0 : payload.broadbandCart) || (payload === null || payload === void 0 ? void 0 : payload.businessAppCart))
        && (((_a = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _a === void 0 ? void 0 : _a.customerType) === 'CONSUMER'
            || ((_b = payload === null || payload === void 0 ? void 0 : payload.businessAppCart) === null || _b === void 0 ? void 0 : _b.customerType) === 'CONSUMER')) {
        isShareCartEligible = true;
    }
    return isShareCartEligible;
}
exports.checkShareCartEligibility = checkShareCartEligibility;
function getEAPDetails() {
    var eapDetails = {
        activatedDeviceMake: '',
        activatedDeviceModel: '',
        deviceSubType: '',
        eapFlowType: '',
        isEAPFlow: false,
        simType: '',
    };
    var orderSubType = commonUtils.getOrderSubType();
    if (orderSubType) {
        var respOrderSubType = orderSubType.toUpperCase();
        switch (respOrderSubType) {
            case 'NEW_WIRELESS_ACTIVATION':
            case 'NEW_WIRELESS_ACTIVATION_NEW_HBOMAX':
                eapDetails.eapFlowType = 'NEW_EAP';
                eapDetails.isEAPFlow = true;
                break;
            case 'NEW_WIRELESS_ON_ACTIVATION':
            case 'NEW_WIRELESS_ON_ACTIVATION_NEW_HBOMAX':
                eapDetails.eapFlowType = 'NEW_EAP_ON';
                eapDetails.isEAPFlow = true;
                break;
            case 'AAL_WIRELESS_ACTIVATION':
            case 'AAL_WIRELESS_ACTIVATION_NEW_HBOMAX':
                eapDetails.eapFlowType = 'AAL_EAP';
                eapDetails.isEAPFlow = true;
                break;
            case 'AAL_WIRELESS_ON_ACTIVATION':
            case 'AAL_WIRELESS_ON_ACTIVATION_NEW_HBOMAX':
                eapDetails.eapFlowType = 'AAL_EAP_ON';
                eapDetails.isEAPFlow = true;
                break;
            default:
                eapDetails.eapFlowType = '';
                eapDetails.isEAPFlow = false;
                break;
        }
    }
    var payload = commonUtils.getCartResp();
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        var wirelessLosgs_1 = payload.wirelessCart.losgs;
        if (wirelessLosgs_1) {
            Object.keys(wirelessLosgs_1).forEach(function (losg) {
                var lineItems = wirelessLosgs_1[losg].lineItems;
                if (lineItems) {
                    Object.keys(lineItems).forEach(function (key) {
                        var _a, _b, _c, _d;
                        if (lineItems[key].itemType && lineItems[key].itemType === 'device'
                            && Common.isKeyExist(lineItems[key], 'hardGood.make')) {
                            eapDetails.activatedDeviceMake = lineItems[key].hardGood.make;
                            eapDetails.activatedDeviceModel = lineItems[key].hardGood.model;
                            if (((_a = lineItems[key]._itemExtraAttributes) === null || _a === void 0 ? void 0 : _a.simType) && eapDetails.isEAPFlow) {
                                eapDetails.simType = lineItems[key]._itemExtraAttributes.simType;
                            }
                            eapDetails.deviceSubType = (_d = (_c = (_b = lineItems[key]) === null || _b === void 0 ? void 0 : _b.hardGood) === null || _c === void 0 ? void 0 : _c.wirelessHardGoodCharacteristics) === null || _d === void 0 ? void 0 : _d._deviceSubType;
                        }
                    });
                }
            });
        }
    }
    return eapDetails;
}
exports.getEAPDetails = getEAPDetails;
function isBYODFlow() {
    var _a;
    var response = {
        isBYODFlow: false,
        isMixedFlowWithBYOD: false,
    };
    var isByodDevicePresent = false;
    var isNONBYODDevicePresent = false;
    var cartResponse = commonUtils.getCartResp();
    if ((_a = cartResponse === null || cartResponse === void 0 ? void 0 : cartResponse.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs) {
        var losgs = Object.values(cartResponse.wirelessCart.losgs);
        if (losgs) {
            losgs.forEach(function (losg) {
                var items = Object.values(losg.lineItems);
                if (items) {
                    items.forEach(function (item) {
                        var _a, _b;
                        if (((_a = item.hardGood) === null || _a === void 0 ? void 0 : _a.hardGoodType) === 'DEVICE') {
                            if ((_b = item.hardGood) === null || _b === void 0 ? void 0 : _b.byodIndicator) {
                                isByodDevicePresent = true;
                            }
                            else {
                                isNONBYODDevicePresent = true;
                            }
                        }
                    });
                }
            });
        }
    }
    if (isByodDevicePresent && !isNONBYODDevicePresent) {
        response.isBYODFlow = true;
    }
    else if (isByodDevicePresent && isNONBYODDevicePresent) {
        response.isMixedFlowWithBYOD = true;
    }
    return response;
}
exports.isBYODFlow = isBYODFlow;
function getCartPanelCollpaseContext() {
    var cartPanelCollapseFlags = {
        collapseOnInitial: false,
        displayCollapseOption: false,
    };
    if (commonUtils.IsWirelessInCart()) {
        cartPanelCollapseFlags.displayCollapseOption = false;
        cartPanelCollapseFlags.collapseOnInitial = false;
    }
    return cartPanelCollapseFlags;
}
exports.getCartPanelCollpaseContext = getCartPanelCollpaseContext;
function checkCartRedirectionAfterRemove(removeResponse) {
    if (removeResponse && removeResponse.content && removeResponse.content.payload &&
        removeResponse.content.payload.redirect) {
        if (removeResponse.content.payload.redirectUrl) {
            var removeRedirectURL = commonUtils.getEditLinkUrl(removeResponse.content.payload.redirectUrl);
            routables_1.history.push(removeRedirectURL);
        }
    }
}
exports.checkCartRedirectionAfterRemove = checkCartRedirectionAfterRemove;
function isSharedRetrievedCart() {
    var payload = commonUtils.getCartResp();
    if (payload && payload.shareCart) {
        return true;
    }
    return false;
}
exports.isSharedRetrievedCart = isSharedRetrievedCart;
function getUrlParamValue(queryString, url) {
    var filter = new RegExp('[?&]' + queryString + '=([^&#]*)');
    var paramValue = filter.exec(url);
    return paramValue ? paramValue[1] : null;
}
exports.getUrlParamValue = getUrlParamValue;
function isMobileUserAgent() {
    if (navigator && navigator.userAgent) {
        return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    return false;
}
exports.isMobileUserAgent = isMobileUserAgent;
// This function is being used in idse-core-ui
exports.lobCartKeys = new Map([
    ['DTVS', { metadata: 'dtvsMetadata', cartKey: 'dtvsCart' }],
    ['IPTV', { metadata: 'iptvMetadata', cartKey: 'iptvCart' }],
    ['BROADBAND', { metadata: 'broadbandMetadata', cartKey: 'broadbandCart' }],
    ['DTVNOW', { metadata: 'dtvMetadata', cartKey: 'dtvnowCart' }],
    ['WIRELESS', { metadata: 'wirelessMetadata', cartKey: 'wirelessCart' }],
]);
function getTradeInPortInConsented() {
    var portInIndicators = {
        hylatradeInCustomerConsented: false,
        portInCustomerConsented: false,
    };
    var payload = commonUtils.getCartResp();
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.keys(payload.wirelessCart.losgs).forEach(function (key) {
            if (payload.wirelessCart.losgs[key] &&
                payload.wirelessCart.losgs[key].
                    _hylaTradeInCustomerConsented !== undefined) {
                portInIndicators.hylatradeInCustomerConsented =
                    payload.wirelessCart.losgs[key].
                        _hylaTradeInCustomerConsented;
            }
            if (payload.wirelessCart.losgs[key] &&
                payload.wirelessCart.losgs[key].
                    _portinCustomerConsented !== undefined) {
                portInIndicators.portInCustomerConsented =
                    payload.wirelessCart.losgs[key].
                        _portinCustomerConsented;
            }
        });
    }
    return portInIndicators;
}
exports.getTradeInPortInConsented = getTradeInPortInConsented;
function getPostpaidflowtype() {
    var orderSubType = commonUtils.getOrderSubType();
    var flowtype = '';
    if (orderSubType) {
        if (orderSubType === 'AAL_WIRELESS') {
            flowtype = 'AL';
        }
        if (orderSubType === 'UPGRADE_WIRELESS' || orderSubType === 'UP_AL_WIRELESS') {
            flowtype = 'UP';
        }
    }
    return flowtype;
}
exports.getPostpaidflowtype = getPostpaidflowtype;
function checkNewBBCart() {
    var orderSubType = commonUtils.getOrderSubType();
    var isNewBBCart = false;
    if (orderSubType === 'NEW_BROADBAND' || orderSubType === 'NEW_BROADBAND_NEW_HBOMAX') {
        isNewBBCart = true;
    }
    return isNewBBCart;
}
exports.checkNewBBCart = checkNewBBCart;
function getCloserCouponFlag() {
    var payload = commonUtils.getCartResp();
    if (payload && payload.enableWirelessRewardsCoupon) {
        return true;
    }
    return false;
}
exports.getCloserCouponFlag = getCloserCouponFlag;
function getAcpCustomerStatusFromSessionStorage() {
    return JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem('acpCustomerStatus'));
}
exports.getAcpCustomerStatusFromSessionStorage = getAcpCustomerStatusFromSessionStorage;
function removeAcpCustomerStatusFromSessionStorage() {
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.removeItem('acpCustomerStatus');
}
exports.removeAcpCustomerStatusFromSessionStorage = removeAcpCustomerStatusFromSessionStorage;
function setAcpCustomerPropsInSessionStorage(serviceType) {
    var appId = 'CART';
    var isExistingCustomer = commonUtils.isAuthuser() ? true : false;
    var returnURL = '/buy/cart/';
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem('acpCustomerProps', JSON.stringify({ appId: appId, isExistingCustomer: isExistingCustomer, serviceType: serviceType, returnURL: returnURL }));
}
exports.setAcpCustomerPropsInSessionStorage = setAcpCustomerPropsInSessionStorage;
function getAcpEligibilityPromo() {
    var _a, _b, _c, _d;
    var acpEligibilityPromo = null;
    var payload = commonUtils.getCartResp();
    if (((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _a === void 0 ? void 0 : _a.promotions) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        acpEligibilityPromo = (_d = (_c = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _c === void 0 ? void 0 : _c.promotions) === null || _d === void 0 ? void 0 : _d.find(function (promo) {
            return ((promo === null || promo === void 0 ? void 0 : promo.acpEligibility) === 'TRIBAL' || (promo === null || promo === void 0 ? void 0 : promo.acpEligibility) === 'NON_TRIBAL');
        });
        return acpEligibilityPromo;
    }
}
exports.getAcpEligibilityPromo = getAcpEligibilityPromo;
function getAcpAccessPromo() {
    var _a, _b, _c, _d;
    var acpAccessPromo = null;
    var payload = commonUtils.getCartResp();
    if (((_b = (_a = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _a === void 0 ? void 0 : _a.promotions) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        acpAccessPromo = (_d = (_c = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _c === void 0 ? void 0 : _c.promotions) === null || _d === void 0 ? void 0 : _d.find(function (promo) {
            return promo === null || promo === void 0 ? void 0 : promo.isAccessPromo;
        });
        return acpAccessPromo;
    }
}
exports.getAcpAccessPromo = getAcpAccessPromo;
function acpVerification() {
    var payload = commonUtils.getCartResp();
    if ((payload === null || payload === void 0 ? void 0 : payload.acpVerification) === true) {
        return true;
    }
    return false;
}
exports.acpVerification = acpVerification;
function isAcpSystemError() {
    var payload = commonUtils.getCartResp();
    if ((payload === null || payload === void 0 ? void 0 : payload.acpSystemError) === true) {
        return true;
    }
    return false;
}
exports.isAcpSystemError = isAcpSystemError;
function enableBillComponent() {
    var payload = commonUtils.getCartResp();
    if (payload && payload.enableBillEstimatorComponent && !isSMBCustomer()) {
        return true;
    }
    return false;
}
exports.enableBillComponent = enableBillComponent;
function getPscBBFlag() {
    return JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem('PSCBB_DTVSIntent'));
}
exports.getPscBBFlag = getPscBBFlag;
function isSMBCustomer() {
    var payload = commonUtils.getCartResp();
    if ((payload && payload.b2bDetail &&
        payload.b2bDetail._enterpriseType &&
        payload.b2bDetail._enterpriseType === 'CRU')
        || (payload &&
            payload.wirelessCart
            && payload.wirelessCart._orderExtraAttributes
            && payload.wirelessCart._orderExtraAttributes._isSMBCustomer
            && payload.wirelessCart._orderExtraAttributes._isSMBCustomer === 'true')) {
        return true;
    }
    return false;
}
exports.isSMBCustomer = isSMBCustomer;
function isWirelessPropMessagingEnabled() {
    var payload = commonUtils.getCartResp();
    if (payload && payload.enableWlsCloserMessagingModel) {
        return true;
    }
    return false;
}
exports.isWirelessPropMessagingEnabled = isWirelessPropMessagingEnabled;
function getLegalIDPUrl(legaltype, wirelesscms, isPrepaid, externalOrderSourceType) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37;
    var legalpath = '';
    var legallinktext = '';
    var legalshorttext = '';
    if (legaltype) {
        var legaltypeValue = legaltype.toLowerCase();
        if (legaltypeValue === 'onfirstbill') {
            if (externalOrderSourceType && wirelesscms.externalOrderSourceOnFirstBillLegal) {
                legalpath = (_b = (_a = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.externalOrderSourceOnFirstBillLegal) === null || _a === void 0 ? void 0 : _a.legalModalPath) === null || _b === void 0 ? void 0 : _b[0];
                legallinktext = (_d = (_c = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.externalOrderSourceOnFirstBillLegal) === null || _c === void 0 ? void 0 : _c.legalShortPath) === null || _d === void 0 ? void 0 : _d.shortLegalLinkLabel;
                legalshorttext = (_f = (_e = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.externalOrderSourceOnFirstBillLegal) === null || _e === void 0 ? void 0 : _e.legalShortPath) === null || _f === void 0 ? void 0 : _f.legalText;
            }
            else if (isSMBCustomer()) {
                legalpath = (_h = (_g = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.smbDueOnFirstBillLegalIDP) === null || _g === void 0 ? void 0 : _g.legalModalPath) === null || _h === void 0 ? void 0 : _h[0];
                legallinktext = (_k = (_j = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.smbDueOnFirstBillLegalIDP) === null || _j === void 0 ? void 0 : _j.legalShortPath) === null || _k === void 0 ? void 0 : _k.shortLegalLinkLabel;
                legalshorttext = (_m = (_l = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.smbDueOnFirstBillLegalIDP) === null || _l === void 0 ? void 0 : _l.legalShortPath) === null || _m === void 0 ? void 0 : _m.legalText;
            }
            else {
                if (wirelesscms.dueOnFirstBillLegalIDP) {
                    legalpath = (_p = (_o = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueOnFirstBillLegalIDP) === null || _o === void 0 ? void 0 : _o.legalModalPath) === null || _p === void 0 ? void 0 : _p[0];
                    legallinktext = (_r = (_q = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueOnFirstBillLegalIDP) === null || _q === void 0 ? void 0 : _q.legalShortPath) === null || _r === void 0 ? void 0 : _r.shortLegalLinkLabel;
                    legalshorttext = (_t = (_s = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueOnFirstBillLegalIDP) === null || _s === void 0 ? void 0 : _s.legalShortPath) === null || _t === void 0 ? void 0 : _t.legalText;
                }
            }
        }
        else if (legaltypeValue === 'onmonthly') {
            if (wirelesscms.dueMonthlyLegalIDP && !isPrepaid) {
                legalpath = (_v = (_u = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueMonthlyLegalIDP) === null || _u === void 0 ? void 0 : _u.legalModalPath) === null || _v === void 0 ? void 0 : _v[0];
                legallinktext = (_x = (_w = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueMonthlyLegalIDP) === null || _w === void 0 ? void 0 : _w.legalShortPath) === null || _x === void 0 ? void 0 : _x.shortLegalLinkLabel;
                legalshorttext = (_z = (_y = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueMonthlyLegalIDP) === null || _y === void 0 ? void 0 : _y.legalShortPath) === null || _z === void 0 ? void 0 : _z.legalText;
            }
            else if (wirelesscms.dueMonthlyPrepaidLegalIDP && isPrepaid) {
                legalpath = (_1 = (_0 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueMonthlyPrepaidLegalIDP) === null || _0 === void 0 ? void 0 : _0.legalModalPath) === null || _1 === void 0 ? void 0 : _1[0];
                legallinktext = (_3 = (_2 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueMonthlyPrepaidLegalIDP) === null || _2 === void 0 ? void 0 : _2.legalShortPath) === null || _3 === void 0 ? void 0 : _3.shortLegalLinkLabel;
                legalshorttext = (_5 = (_4 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueMonthlyPrepaidLegalIDP) === null || _4 === void 0 ? void 0 : _4.legalShortPath) === null || _5 === void 0 ? void 0 : _5.legalText;
            }
        }
        else if (legaltypeValue === 'ontoday') {
            if (isSMBCustomer()) {
                legalpath = (_6 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.smbDueTodayLegalIDP.legalModalPath) === null || _6 === void 0 ? void 0 : _6[0];
                legallinktext = (_8 = (_7 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.smbDueTodayLegalIDP) === null || _7 === void 0 ? void 0 : _7.legalShortPath) === null || _8 === void 0 ? void 0 : _8.shortLegalLinkLabel;
                legalshorttext = (_10 = (_9 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.smbDueTodayLegalIDP) === null || _9 === void 0 ? void 0 : _9.legalShortPath) === null || _10 === void 0 ? void 0 : _10.legalText;
            }
            else {
                if (wirelesscms.dueTodayLegalIDP && !isPrepaid) {
                    legalpath = (_12 = (_11 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueTodayLegalIDP) === null || _11 === void 0 ? void 0 : _11.legalModalPath) === null || _12 === void 0 ? void 0 : _12[0];
                    legallinktext = (_14 = (_13 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueTodayLegalIDP) === null || _13 === void 0 ? void 0 : _13.legalShortPath) === null || _14 === void 0 ? void 0 : _14.shortLegalLinkLabel;
                    legalshorttext = (_16 = (_15 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueTodayLegalIDP) === null || _15 === void 0 ? void 0 : _15.legalShortPath) === null || _16 === void 0 ? void 0 : _16.legalText;
                }
                else if (wirelesscms.dueTodayPrepaidLegalIDP && isPrepaid) {
                    legalpath = (_18 = (_17 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueTodayPrepaidLegalIDP) === null || _17 === void 0 ? void 0 : _17.legalModalPath) === null || _18 === void 0 ? void 0 : _18[0];
                    legallinktext = (_20 = (_19 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueTodayPrepaidLegalIDP) === null || _19 === void 0 ? void 0 : _19.legalShortPath) === null || _20 === void 0 ? void 0 : _20.shortLegalLinkLabel;
                    legalshorttext = (_22 = (_21 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.dueTodayPrepaidLegalIDP) === null || _21 === void 0 ? void 0 : _21.legalShortPath) === null || _22 === void 0 ? void 0 : _22.legalText;
                }
            }
        }
        else if (legaltypeValue === 'attfees') {
            if (wirelesscms && (wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.govTaxAndFeeIDP)) {
                legalpath = (((_23 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.govTaxAndFeeIDP) === null || _23 === void 0 ? void 0 : _23.legalModalPath) && ((_25 = (_24 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.govTaxAndFeeIDP) === null || _24 === void 0 ? void 0 : _24.legalModalPath) === null || _25 === void 0 ? void 0 : _25[0])) ? (_27 = (_26 = wirelesscms.govTaxAndFeeIDP) === null || _26 === void 0 ? void 0 : _26.legalModalPath) === null || _27 === void 0 ? void 0 : _27[0] : '';
                legallinktext = (((_28 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.govTaxAndFeeIDP) === null || _28 === void 0 ? void 0 : _28.legalShortPath) && ((_30 = (_29 = wirelesscms.govTaxAndFeeIDP) === null || _29 === void 0 ? void 0 : _29.legalShortPath) === null || _30 === void 0 ? void 0 : _30.shortLegalLinkLabel)) ? (_32 = (_31 = wirelesscms.govTaxAndFeeIDP) === null || _31 === void 0 ? void 0 : _31.legalShortPath) === null || _32 === void 0 ? void 0 : _32.shortLegalLinkLabel : '';
                legalshorttext = (((_33 = wirelesscms === null || wirelesscms === void 0 ? void 0 : wirelesscms.govTaxAndFeeIDP) === null || _33 === void 0 ? void 0 : _33.legalShortPath) && ((_35 = (_34 = wirelesscms.govTaxAndFeeIDP) === null || _34 === void 0 ? void 0 : _34.legalShortPath) === null || _35 === void 0 ? void 0 : _35.legalText)) ? (_37 = (_36 = wirelesscms.govTaxAndFeeIDP) === null || _36 === void 0 ? void 0 : _36.legalShortPath) === null || _37 === void 0 ? void 0 : _37.legalText : '';
            }
        }
    }
    return {
        legalModalPath: legalpath,
        legallinkText: legallinktext,
        shortText: legalshorttext,
    };
}
exports.getLegalIDPUrl = getLegalIDPUrl;
function getLegalIDPDetails(legalIDPObj) {
    var legalpath = '';
    var legallinktext = '';
    var legalshorttext = '';
    if (legalIDPObj) {
        legalpath = legalIDPObj.legalModalPath[0];
        legallinktext = legalIDPObj.legalShortPath.shortLegalLinkLabel;
        legalshorttext = legalIDPObj.legalShortPath.legalText;
    }
    return {
        legalModalPath: legalpath,
        legallinkText: legallinktext,
        shortText: legalshorttext,
    };
}
exports.getLegalIDPDetails = getLegalIDPDetails;
function getEnabledeviceLegalMessage() {
    var payload = commonUtils.getCartResp();
    if (payload === null || payload === void 0 ? void 0 : payload.enabledeviceLegalMessage) {
        return true;
    }
    return false;
}
exports.getEnabledeviceLegalMessage = getEnabledeviceLegalMessage;
function getIsGigaInCart() {
    var payload = commonUtils.getCartResp();
    if (payload &&
        payload.broadbandCart && payload.broadbandCart.isGigaInCart) {
        return payload.broadbandCart.isGigaInCart;
    }
    else {
        return false;
    }
}
exports.getIsGigaInCart = getIsGigaInCart;
function isExpupgradeViewEnable() {
    var payload = commonUtils.getCartResp();
    if (payload &&
        payload.enableExpupgradeView) {
        return payload.enableExpupgradeView;
    }
    else {
        return false;
    }
}
exports.isExpupgradeViewEnable = isExpupgradeViewEnable;
function isQueryInURL(url, queryString) {
    var queryParam = url.split('?')[1];
    if (queryParam) {
        var parmaArry = queryParam.split('&');
        if (parmaArry.includes(queryString)) {
            return true;
        }
        else {
            return false;
        }
    }
    else {
        return false;
    }
}
exports.isQueryInURL = isQueryInURL;
function getItemsListFromLOB(losgs) {
    var finalSKUsList = '';
    if (losgs) {
        var losgValues = Object.values(losgs);
        losgValues.forEach(function (val) {
            var lineItems = Object.values(val && val.lineItems);
            if (lineItems) {
                lineItems.forEach(function (item) {
                    if (item && item.hardGood && (item.hardGood.hardGoodType === 'DEVICE')) {
                        finalSKUsList = finalSKUsList + (finalSKUsList !== '' ? ',' : '') + item.productSKU;
                    }
                });
            }
        });
    }
    return finalSKUsList;
}
exports.getItemsListFromLOB = getItemsListFromLOB;
function getPlanListFromLOB(losgs) {
    var finalPlansList = '';
    if (losgs) {
        var losgValues = Object.values(losgs);
        losgValues.forEach(function (val) {
            var lineItems = Object.values(val && val.lineItems);
            if (lineItems) {
                lineItems.forEach(function (item) {
                    if (item && item.productType && (item.productType === 'PLAN')) {
                        finalPlansList = finalPlansList + (finalPlansList !== '' ? ',' : '') + item.billingCode;
                    }
                });
            }
        });
    }
    return finalPlansList;
}
exports.getPlanListFromLOB = getPlanListFromLOB;
function globalNavForSMBCustomer() {
    if (isSMBCustomer()) {
        setCustomerTypeParamsForGlobalNav();
    }
}
exports.globalNavForSMBCustomer = globalNavForSMBCustomer;
function setCustomerTypeParamsForGlobalNav() {
    // tslint:disable-next-line:no-any
    var globalNav = document.querySelector('attwc-globalnav-header');
    if (globalNav && globalNav.customerType) {
        globalNav.customerType = 'smb';
        globalNav.excludeCoreElements = 'search';
    }
    globalNav = document.querySelector('attwc-globalnav-footer');
    if (globalNav && globalNav.customerType) {
        globalNav.customerType = 'smb';
    }
}
exports.setCustomerTypeParamsForGlobalNav = setCustomerTypeParamsForGlobalNav;
/* export const isEligibleActionsMNM = () => {
    const payload = commonUtils.getCartResp();
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        const keys = Object.keys(payload.wirelessCart.losgs);
        if (keys &&
            keys.length >= 1 &&
            ((payload.wirelessCart.losgs[keys[0]] &&
                payload.wirelessCart.losgs[keys[0]].eligibleActions &&
                payload.wirelessCart.losgs[keys[0]].eligibleActions
                    .indexOf('ADD_DEVICE_MNM') > -1) ||
                (payload.wirelessCart.losgs[keys[keys.length - 1]] &&
                    payload.wirelessCart.losgs[keys[keys.length - 1]].eligibleActions &&
                    payload.wirelessCart.losgs[keys[keys.length - 1]].eligibleActions
                        .indexOf('ADD_DEVICE_MNM') > -1))) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}; */
function getLinkClickBasekUrl() {
    var expressView = isExpupgradeViewEnable();
    if (expressView) {
        return ReportingService_1.PageUrls.CARTVIEW_PAGE;
    }
    else {
        return ReportingService_1.PageUrls.CART_PAGE;
    }
}
exports.getLinkClickBasekUrl = getLinkClickBasekUrl;
function getLinkClickBaseUrlforNMDPR() {
    var _a;
    var payload = commonUtils.getCartResp();
    var losgCount = Object.keys((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.losgs).length;
    var expressView = isExpupgradeViewEnable();
    var linkDUrlMandate;
    if (expressView) {
        linkDUrlMandate = ReportingService_1.PageUrls.DS_CHECKOUT_Zipcode_Mandate_Modal;
        if (losgCount > 1) {
            linkDUrlMandate = ReportingService_1.PageUrls.DS_CHECKOUT_Zipcode_Multiline_Modal;
        }
    }
    else {
        var checkoutView = window.location.href.includes('checkout');
        linkDUrlMandate = checkoutView ?
            ReportingService_1.PageUrls.DS_CHECKOUT_Zipcode_Mandate_Modal : ReportingService_1.PageUrls.DS_Cart_Zipcode_Mandate_Modal;
        if (losgCount > 1) {
            linkDUrlMandate = checkoutView ?
                ReportingService_1.PageUrls.DS_CHECKOUT_Zipcode_Multiline_Modal : ReportingService_1.PageUrls.DS_Cart_Zipcode_Multiline_Modal;
        }
    }
    return linkDUrlMandate;
}
exports.getLinkClickBaseUrlforNMDPR = getLinkClickBaseUrlforNMDPR;
var CHANNEL_TYPE;
(function (CHANNEL_TYPE) {
    CHANNEL_TYPE["CHANNEL_NATIVE"] = "native";
    CHANNEL_TYPE["CHANNEL_EMAIL"] = "email";
})(CHANNEL_TYPE = exports.CHANNEL_TYPE || (exports.CHANNEL_TYPE = {}));
function getHylaPromotionId() {
    var payload = commonUtils.getCartResp();
    var promotionCode = '';
    if (payload && payload.wirelessCart
        && payload.wirelessCart.promotions
        && payload.wirelessCart.promotions.length) {
        payload.wirelessCart.promotions.forEach(function (promo) {
            if (promo.promotionCategory && promo.promotionCategory.toUpperCase() === 'HYLA_TRADEIN') {
                promotionCode = promo.promotionCode ? promo.promotionCode : promo.promotionId;
            }
        });
    }
    return promotionCode;
}
exports.getHylaPromotionId = getHylaPromotionId;
function getHylaPromotionBillingCode() {
    var payload = commonUtils.getCartResp();
    var promotionBillingCode = '';
    if (payload && payload.wirelessCart
        && payload.wirelessCart.promotions
        && payload.wirelessCart.promotions.length) {
        payload.wirelessCart.promotions.forEach(function (promo) {
            if (promo.promotionCategory && promo.promotionCategory.toUpperCase() === 'HYLA_TRADEIN') {
                promotionBillingCode = promo.promotionBillingCode ? promo.promotionBillingCode : promo.promotionId;
            }
        });
    }
    return promotionBillingCode;
}
exports.getHylaPromotionBillingCode = getHylaPromotionBillingCode;
function hasDiscountCategoryTradeIn(category) {
    var payload = commonUtils.getCartResp();
    var hasPromoCategoryTradeIn = false;
    if (payload && payload.wirelessCart && payload.wirelessCart.promotions && payload.wirelessCart.promotions.length) {
        payload.wirelessCart.promotions.forEach(function (promo) {
            if (promo.discountCategory && promo.discountCategory.toLowerCase() === category.toLowerCase()) {
                hasPromoCategoryTradeIn = true;
            }
        });
    }
    return hasPromoCategoryTradeIn;
}
exports.hasDiscountCategoryTradeIn = hasDiscountCategoryTradeIn;
exports.isIncompleteCart = function () {
    var isCartIncomplete = false;
    var payload = commonUtils.getCartResp();
    if (payload) {
        var info = payload;
        if (info.wirelessCart && info.wirelessCart.requiredToCheckout) {
            var requiredToCheckout = info.wirelessCart.requiredToCheckout;
            for (var _i = 0, requiredToCheckout_1 = requiredToCheckout; _i < requiredToCheckout_1.length; _i++) {
                var itemRC = requiredToCheckout_1[_i];
                if (itemRC) {
                    isCartIncomplete = true;
                }
            }
        }
        else if (info.commonCart && info.commonCart.requiredToCheckout) {
            var requiredToCheckout = info.commonCart.requiredToCheckout;
            for (var _a = 0, requiredToCheckout_2 = requiredToCheckout; _a < requiredToCheckout_2.length; _a++) {
                var itemRC = requiredToCheckout_2[_a];
                if (itemRC) {
                    isCartIncomplete = true;
                }
            }
        }
        else if (info && info.cartStatus &&
            !info.cartStatus.readyToCheckout && info.cartStatus.cartState &&
            info.cartStatus.cartState.toUpperCase() === 'INCOMPLETE') {
            isCartIncomplete = true;
        }
    }
    return isCartIncomplete;
};
function isEdspCreditCheck() {
    var payload = commonUtils.getCartResp();
    return !!(payload === null || payload === void 0 ? void 0 : payload.enableEdspCreditCheck);
}
exports.isEdspCreditCheck = isEdspCreditCheck;
function isEnableCreditCheckText() {
    var payload = commonUtils.getCartResp();
    return !!(payload && payload.enableCreditCheckText);
}
exports.isEnableCreditCheckText = isEnableCreditCheckText;
function getLobLosgsCommonCart(losgs, lobType) {
    var _a, _b;
    var losgsObj = losgs;
    var commonCart = {
        losgs: {},
    };
    if (losgs && lobType) {
        for (var objProp in losgsObj) {
            if (losgsObj[objProp] && losgsObj[objProp].productCategory &&
                losgsObj[objProp].productCategory === lobType) {
                var id = (_b = (_a = losgsObj[objProp]) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.toString();
                losgsObj[objProp].displayLine = true; // add for BSSE flow default value
                commonCart.losgs[id] = losgsObj[objProp];
            }
        }
    }
    return commonCart.losgs;
}
exports.getLobLosgsCommonCart = getLobLosgsCommonCart;
function getWirelessCart() {
    if (commonUtils.IsWirelessInCart()) {
        var payload = commonUtils.getCartResp();
        if (payload.commonCart && payload.commonCart.losgs) {
            var wlsCartData = {
                losgList: [],
                losgs: {},
                promotions: payload.commonCart.promotions || [],
            };
            wlsCartData.losgs = getLobLosgsCommonCart(payload.commonCart.losgs, commonUtils.LOBNames.LOB_WIRELESS);
            var orderPriceObj = payload.orderPriceInfo;
            payload.wirelessCart = wlsCartData;
            if (payload.commonCart.account) {
                payload.wirelessCart.account = payload.commonCart.account;
            }
            payload.wirelessCart.totalLobDueMonthly = orderPriceObj && orderPriceObj.dueMonthly;
            payload.wirelessCart.totalLobDueToday = orderPriceObj && orderPriceObj.dueToday;
            payload.wirelessCart.dueTodayFirstMonth = orderPriceObj && orderPriceObj.dueTodayFirstMonth;
            payload.wirelessCart.dueTodayOneTime = orderPriceObj && orderPriceObj.dueTodayOneTime;
            payload.wirelessCart.dueTodayOneTimeTaxes = orderPriceObj && orderPriceObj.dueTodayOneTimeTaxes;
            payload.wirelessCart.existingLineOneTimeCredit = orderPriceObj && orderPriceObj.existingLineOneTimeCredit;
            return payload;
        }
        else {
            return payload;
        }
    }
    else {
        return null;
    }
}
exports.getWirelessCart = getWirelessCart;
function getAccessoryCart() {
    var payload = commonUtils.getCartResp();
    if (payload.commonCart && payload.commonCart.losgs) {
        var orderPriceObj = payload.orderPriceInfo;
        var cartData = {
            losgs: {},
            promotions: payload.commonCart.promotions || [],
            totalLob1stBill: orderPriceObj && orderPriceObj.dueTodayFirstMonth,
            totalLobDueMonthly: orderPriceObj && orderPriceObj.dueMonthly,
            totalLobDueToday: orderPriceObj && orderPriceObj.dueToday,
            totalLobTax: orderPriceObj && orderPriceObj.tax,
        };
        cartData.losgs = getLobLosgsCommonCart(payload.commonCart.losgs, commonUtils.LOBNames.LOB_ACCESSORY);
        payload.accessoryCart = cartData;
        return payload;
    }
    else {
        return payload;
    }
}
exports.getAccessoryCart = getAccessoryCart;
exports.isNewWirelessPostpaidView = function () {
    var payload = commonUtils.getCartResp();
    return !!(payload && (!commonUtils.isAuthuser() || commonUtils.isNewWirelessFlow()));
};
exports.isDisplayPrepaidBillingTax = function () {
    var payload = commonUtils.getCartResp();
    return !!(payload &&
        payload.enableDisplayPrepaidBillingTax);
};
function isPrivateOffersApplied() {
    var _a, _b;
    var payload = commonUtils.getCartResp();
    return !!(payload && (((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.privateOfferApplied) || ((_b = payload === null || payload === void 0 ? void 0 : payload.broadbandCart) === null || _b === void 0 ? void 0 : _b.privateOfferApplied)));
}
exports.isPrivateOffersApplied = isPrivateOffersApplied;
function isSpecialBBPricing(cmsKey) {
    var payload = commonUtils.getCartResp();
    var isSpecialPricing = false;
    if (payload && payload.broadbandCart && payload.broadbandCart.hsiaSwimlane) {
        var swimLane = payload.broadbandCart.hsiaSwimlane;
        if (cmsKey && cmsKey.split(',') && cmsKey.split(',').length > 0) {
            isSpecialPricing = cmsKey.split(',').includes(swimLane);
        }
    }
    return isSpecialPricing;
}
exports.isSpecialBBPricing = isSpecialBBPricing;
function getSavingsPromoFlags() {
    var payload = commonUtils.getCartResp();
    var savingsPromoDetails = {};
    if (payload && payload.savingsPromoDetails) {
        savingsPromoDetails = {
            savingsPromoComponentDisplay: payload.savingsPromoDetails &&
                payload.savingsPromoDetails.savingsPromoComponentDisplay,
            savingsPromoComponentExpandedByDefault: payload.savingsPromoDetails &&
                payload.savingsPromoDetails.savingsPromoComponentExpandedByDefault,
        };
        return savingsPromoDetails;
    }
    else {
        return savingsPromoDetails;
    }
}
exports.getSavingsPromoFlags = getSavingsPromoFlags;
function isAppreciationOfferPresent() {
    var payload = commonUtils.getCartResp();
    return !!(payload && payload.appreciationOfferPresent);
}
exports.isAppreciationOfferPresent = isAppreciationOfferPresent;
function isPreScreenCreditCheck() {
    var payload = commonUtils.getCartResp();
    return !!(payload && (payload.preScreenCreditCheckDone));
}
exports.isPreScreenCreditCheck = isPreScreenCreditCheck;
function isEnablePrescreenCreditCheckOnCart() {
    var payload = commonUtils.getCartResp();
    return !!(payload && payload.enablePrescreenCreditCheckOnCart);
}
exports.isEnablePrescreenCreditCheckOnCart = isEnablePrescreenCreditCheckOnCart;
// This function will return the post fix for any number. Ex: 1st for 1, 3rd for 3 and 10th for 10
function ordinalPostFix(ordNumber) {
    var englishOrdinalRules = new Intl.PluralRules('en', { type: 'ordinal' });
    var sampelSuffixes = {
        few: 'rd',
        one: 'st',
        other: 'th',
        two: 'nd',
    };
    var postScript = englishOrdinalRules.select(ordNumber);
    var suffix = sampelSuffixes[postScript];
    return ("" + ordNumber + suffix);
}
exports.ordinalPostFix = ordinalPostFix;
function getRedirectionUrl(editurl, alternateUrl, value) {
    var editLink = '';
    var reportingService = new ReportingService_1.default();
    var stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
    editLink = editurl ? editurl : alternateUrl;
    if (commonUtils.isLoginRequiredonCart()) {
        editLink = commonUtils.getauthenticatedPersistantLoginURL(true);
    }
    var editLinkUrl = commonUtils.getEditLinkUrl(editLink);
    reportingService.fireLinkClickWithOutPageLoad(value, editLinkUrl);
    stateManager.set('editLinkUrl', { url: editLinkUrl });
    stateManager.set('CurrentPageURL', { name: editLinkUrl });
    if (editLinkUrl.indexOf('phones') > -1 || editLinkUrl.indexOf('byod') > -1
        || editLinkUrl.indexOf('postpaid') > -1) {
        window.location.href = '/buy' + editLinkUrl;
    }
    else {
        routables_1.history.push(editLinkUrl);
    }
}
exports.getRedirectionUrl = getRedirectionUrl;
function isPrePreOrder() {
    var _a;
    var payload = commonUtils.getCartResp();
    var cartLevelPrePreOrder = (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.prePreOrderIndicator;
    return cartLevelPrePreOrder &&
        (isAtleastOneLineLevelPrePreOrderIndicator() || isAtleastOneLineLevelPreOrderIndicator());
}
exports.isPrePreOrder = isPrePreOrder;
// has at least one lineItem level prePreOrderIndicator as true in any of the losgs
function isAtleastOneLineLevelPrePreOrderIndicator() {
    var payload = commonUtils.getCartResp();
    var atleastOneLineLevelPrePreOrderIndicator = false;
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.keys(payload.wirelessCart.losgs).forEach(function (key) {
            if (atleastOneLineLevelPrePreOrderIndicator === true) {
                return;
            }
            var deviceLineItem = getDeviceDetailsFromLOSG(key);
            atleastOneLineLevelPrePreOrderIndicator = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.prePreOrderIndicator;
        });
    }
    return atleastOneLineLevelPrePreOrderIndicator;
}
exports.isAtleastOneLineLevelPrePreOrderIndicator = isAtleastOneLineLevelPrePreOrderIndicator;
// has at least one lineItem level preOrderIndicator as true in any of the losgs
function isAtleastOneLineLevelPreOrderIndicator() {
    var payload = commonUtils.getCartResp();
    var atleastOneLineLevelPreOrderIndicator = false;
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.keys(payload.wirelessCart.losgs).forEach(function (key) {
            var _a;
            if (atleastOneLineLevelPreOrderIndicator === true) {
                return;
            }
            var deviceLineItem = getDeviceDetailsFromLOSG(key);
            atleastOneLineLevelPreOrderIndicator = (_a = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.hardGood) === null || _a === void 0 ? void 0 : _a.preOrderIndicator;
        });
    }
    return atleastOneLineLevelPreOrderIndicator;
}
exports.isAtleastOneLineLevelPreOrderIndicator = isAtleastOneLineLevelPreOrderIndicator;
function isPersistedCart() {
    var _a;
    var payload = commonUtils.getCartResp();
    return (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.persistedCart;
}
exports.isPersistedCart = isPersistedCart;
function isFNIntentPresent(currentLosg) {
    var payload = commonUtils.getCartResp();
    var fnIntentPresent = false;
    if (currentLosg) {
        fnIntentPresent = currentLosg._fnIntendInd;
    }
    else if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losg) {
            if (losg._fnIntendInd) {
                fnIntentPresent = true;
            }
        });
    }
    return fnIntentPresent;
}
exports.isFNIntentPresent = isFNIntentPresent;
function isFNUserWithConsumerLine() {
    var payload = commonUtils.getCartResp();
    var fnUserWithCustomerLine = false;
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losg) {
            if (losg.firstNetUser) {
                fnUserWithCustomerLine = true;
            }
        });
    }
    return fnUserWithCustomerLine;
}
exports.isFNUserWithConsumerLine = isFNUserWithConsumerLine;
function isFNItentPresentInOtherLosgs(currentLosg) {
    var payload = commonUtils.getCartResp();
    var fnIntentPresent = false;
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losg) {
            if (losg._fnIntendInd && losg.id !== currentLosg.id) {
                fnIntentPresent = true;
            }
        });
    }
    return fnIntentPresent;
}
exports.isFNItentPresentInOtherLosgs = isFNItentPresentInOtherLosgs;
function isFNIntentSignOnRequired() {
    var payload = commonUtils.getCartResp();
    var fnSignOnModelRequired = false;
    if (payload && payload.wirelessCart) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losg) {
            if (!(losg.fnGuId && losg.fnUserId) && losg._fnIntendInd) {
                fnSignOnModelRequired = true;
            }
        });
    }
    return fnSignOnModelRequired;
}
exports.isFNIntentSignOnRequired = isFNIntentSignOnRequired;
function isCartHasOnlyFNLines() {
    var payload = commonUtils.getCartResp();
    var isCartHasOnlyFirstNetLines = true;
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losg) {
            if (!losg._fnIntendInd) {
                isCartHasOnlyFirstNetLines = false;
            }
        });
    }
    else {
        isCartHasOnlyFirstNetLines = false;
    }
    return isCartHasOnlyFirstNetLines;
}
exports.isCartHasOnlyFNLines = isCartHasOnlyFNLines;
function isFNCarribeanUser() {
    var payload = commonUtils.getCartResp();
    var isCarribeanUser = false;
    if (Common.isKeyExist(payload, 'wirelessCart.losgs')) {
        Object.values(payload.wirelessCart.losgs).forEach(function (losg) {
            var _a;
            if ((losg === null || losg === void 0 ? void 0 : losg._fnCaribbean) || ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a._fnCaribbeanOrder)) {
                isCarribeanUser = true;
            }
        });
    }
    return isCarribeanUser;
}
exports.isFNCarribeanUser = isFNCarribeanUser;
function getZipChangeModalStatus() {
    var _a;
    var payload = commonUtils.getCartResp();
    var modalStatus = false;
    var restrictedState = (_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.cartInsuranceInRestrictedState;
    var showModal = JSON.parse(sessionStorage.getItem('isMandateMsgShown'));
    if (!showModal && restrictedState) {
        modalStatus = true;
    }
    return modalStatus;
}
exports.getZipChangeModalStatus = getZipChangeModalStatus;
function isDeviceESimEligible(losg) {
    var _a, _b;
    var isESimEligible = false;
    var deviceLineItem = getDeviceDetailsFromLOSG(losg.id);
    if (((_b = (_a = deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem._itemExtraAttributes) === null || _a === void 0 ? void 0 : _a.simType) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'ESIM') {
        isESimEligible = true;
    }
    return isESimEligible && !WirelessUtilFunctions_1.isBYOD(losg);
}
exports.isDeviceESimEligible = isDeviceESimEligible;
function isParkLosgs(losgs) {
    return losgs.filter(function (losgItem) { var _a; return (_a = losgItem === null || losgItem === void 0 ? void 0 : losgItem.id) === null || _a === void 0 ? void 0 : _a.includes('park'); }).length > 0;
}
exports.isParkLosgs = isParkLosgs;
//# sourceMappingURL=CartUtilFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/utils/CartUtilFunctions.js
// module id = 6
// module chunks = 8